export default __webpack_public_path__ + "static/media/GC_43.60693ab3.png";